var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { FormCoreComponent } from '../form-core';
export var MY_FORMATS = {
    parse: {
        dateInput: 'LL'
    },
    display: {
        dateInput: 'LL',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    }
};
var CustomerFormComponent = /** @class */ (function (_super) {
    __extends(CustomerFormComponent, _super);
    function CustomerFormComponent() {
        var _this = _super.call(this) || this;
        // Date to open date picker at - Jan 1 1970 should save a bit of scrolling over the default of "today"
        _this.startDate = '1970-01-01';
        _this.locationRequest = new EventEmitter();
        _this.form = new FormGroup({
            firstName: new FormControl('', Validators.required),
            lastName: new FormControl('', Validators.required),
            enabled: new FormControl(true),
            dateOfBirth: new FormControl(null),
            about: new FormControl(''),
            profileImage: new FormControl(''),
            urls: new FormArray([]),
            settings: new FormGroup({
                allowMemoImages: new FormControl('')
            }),
            address: new FormGroup({
                address1: new FormControl(''),
                address2: new FormControl(),
                town: new FormControl(''),
                state: new FormControl(''),
                postcode: new FormControl(''),
                country: new FormControl('')
            }),
            location: new FormGroup({
                lat: new FormControl(''),
                lng: new FormControl()
            })
        });
        return _this;
    }
    Object.defineProperty(CustomerFormComponent.prototype, "location", {
        set: function (location) {
            if (location) {
                this.form.controls.location.patchValue(location);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CustomerFormComponent.prototype, "customer", {
        set: function (value) {
            if (value) {
                var result = __assign({}, value);
                if (value.dateOfBirth) {
                    result.dateOfBirth = value.dateOfBirth;
                    this.startDate = value.dateOfBirth;
                }
                result.urls = result.urls || [];
                result.location = result.location || {};
                var groups = result.urls.map(function (url) {
                    return new FormGroup({
                        url: new FormControl('', Validators.required),
                        description: new FormControl('')
                    });
                });
                this.form.setControl('urls', new FormArray(groups));
                this.form.patchValue(result, { emitEvent: false, onlySelf: true });
            }
            else {
                this.form.patchValue({}, { emitEvent: false, onlySelf: true });
            }
        },
        enumerable: true,
        configurable: true
    });
    CustomerFormComponent.prototype.setDate = function (value) {
        this.startDate = value;
        this.form.get('dateOfBirth').setValue(moment(value).format('YYYY-MM-DD'));
    };
    CustomerFormComponent.prototype.findLocation = function () {
        this.locationRequest.emit(this.form.controls.address.value);
    };
    CustomerFormComponent.prototype.addUrl = function () {
        this.form.setControl('urls', new FormArray(this.form.get('urls').controls.concat(new FormGroup({
            url: new FormControl('', Validators.required),
            description: new FormControl('')
        }))));
    };
    CustomerFormComponent.prototype.removeUrl = function (removed) {
        var controls = this.form.get('urls').controls.filter(function (control) { return control !== removed; });
        this.form.setControl('urls', new FormArray(controls));
    };
    CustomerFormComponent.prototype.openUrl = function (item) {
        window.open(item.value.url, '_blank');
    };
    return CustomerFormComponent;
}(FormCoreComponent));
export { CustomerFormComponent };
